// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27white%27 stroke-width=%272%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2364748b%27 stroke-width=%272%27%3E%3Cpath d=%27M6 9l6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* BAInocular NLP Intelligence Engine — mockup-accurate layout */

.nlp-engine-page {
  --nlp-header-bg: linear-gradient(135deg, #1e40af 0%, #2563eb 55%, #3b82f6 100%);
  --nlp-canvas-bg: #eef2f7;
  --nlp-send-bg: #93c5fd;
  --nlp-send-hover: #60a5fa;

  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 0;
  background: var(--nlp-canvas-bg);
  font-family: "Poppins", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

[data-theme="dark"] .nlp-engine-page {
  --nlp-canvas-bg: #0f172a;
  --nlp-send-bg: #3b82f6;
  --nlp-send-hover: #2563eb;
}

/* ── Blue NLP header bar ── */
.nlp-engine-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-shrink: 0;
  padding: 10px 20px;
  background: var(--nlp-header-bg);
  color: #fff;
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  min-height: 56px;
}

.nlp-engine-header-left {
  display: flex;
  align-items: center;
  gap: 14px;
  min-width: 0;
}

.nlp-engine-brand-meta {
  display: flex;
  flex-direction: column;
  gap: 3px;
  min-width: 0;
}

.nlp-engine-subtitle {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.14em;
  color: rgba(255, 255, 255, 0.95);
  white-space: nowrap;
}

.nlp-engine-status {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 0.6875rem;
  font-weight: 500;
  color: rgba(255, 255, 255, 0.9);
}

.nlp-engine-status-dot {
  width: 7px;
  height: 7px;
  border-radius: 50%;
  flex-shrink: 0;
}

.nlp-engine-status.connected .nlp-engine-status-dot {
  background: #4ade80;
  box-shadow: 0 0 6px rgba(74, 222, 128, 0.7);
}

.nlp-engine-status.disconnected .nlp-engine-status-dot {
  background: #f87171;
  box-shadow: 0 0 6px rgba(248, 113, 113, 0.7);
}

.nlp-engine-header-right {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.nlp-engine-btn,
.nlp-engine-icon-btn,
.nlp-engine-new-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s ease, border-color 0.15s ease;
  white-space: nowrap;
}

.nlp-engine-btn:hover,
.nlp-engine-icon-btn:hover,
.nlp-engine-new-btn:hover {
  background: rgba(255, 255, 255, 0.22);
  border-color: rgba(255, 255, 255, 0.5);
}

.nlp-engine-grouping-btn {
  height: 34px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 600;
}

.nlp-engine-grouping-btn.active {
  background: rgba(255, 255, 255, 0.28);
  border-color: rgba(255, 255, 255, 0.65);
}

.nlp-engine-select {
  height: 34px;
  padding: 0 28px 0 10px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.12);
  color: #fff;
  font-size: 0.8125rem;
  font-family: inherit;
  font-weight: 500;
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 8px center;
}

.nlp-engine-select option {
  color: #1e293b;
  background: #fff;
}

.nlp-engine-icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 8px;
  padding: 0;
  flex-shrink: 0;
}

.nlp-engine-theme-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.55);
  background: linear-gradient(135deg, #f472b6, #818cf8);
  cursor: pointer;
  flex-shrink: 0;
  padding: 0;
}

.nlp-engine-new-btn {
  height: 34px;
  padding: 0 12px;
  border-radius: 8px;
  font-size: 0.8125rem;
  font-weight: 600;
}

/* ── Body ── */
.nlp-engine-body {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
  background: var(--nlp-canvas-bg);
}

/* ── Chat view ── */
.nlp-chat-view {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
}

.nlp-messages {
  flex: 1 1;
  overflow-y: auto;
  padding: 28px 24px 12px;
  scroll-behavior: smooth;
}

.nlp-messages-inner {
  max-width: 900px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 0;
}

.nlp-messages::-webkit-scrollbar {
  width: 6px;
}

.nlp-messages::-webkit-scrollbar-thumb {
  background: var(--scrollbar-thumb, #cbd5e1);
  border-radius: 3px;
}

.nlp-welcome-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 8px;
}

.nlp-bot-avatar {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border-radius: 10px;
  background: linear-gradient(135deg, #2563eb, #3b82f6);
  color: #fff;
  font-size: 0.875rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);
}

.nlp-bot-avatar-sm {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  font-size: 0.75rem;
  margin-top: 2px;
}

.nlp-welcome-card {
  flex: 1 1;
  min-width: 0;
  background: var(--surface, #fff);
  border-radius: 14px;
  padding: 22px 26px;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.07);
  border: 1px solid var(--border, #e2e8f0);
}

.nlp-welcome-time {
  display: block;
  font-size: 0.75rem;
  color: var(--text-subtle, #94a3b8);
  margin-bottom: 8px;
}

.nlp-welcome-title {
  margin: 0 0 14px;
  font-size: 1.0625rem;
  font-weight: 700;
  color: #2563eb;
  line-height: 1.4;
}

.nlp-welcome-heading {
  margin: 0 0 10px;
  font-size: 0.9375rem;
  font-weight: 600;
  color: var(--text-strong, #0f172a);
}

.nlp-feature-list {
  list-style: none;
  margin: 0 0 14px;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.nlp-feature-list li {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  font-size: 0.875rem;
  color: var(--text-muted, #64748b);
  line-height: 1.5;
}

.nlp-feature-list li strong {
  color: var(--text-strong, #0f172a);
  font-weight: 600;
}

.nlp-feature-icon {
  flex-shrink: 0;
  font-size: 1rem;
  line-height: 1.35;
}

.nlp-welcome-footer {
  margin: 0;
  padding-top: 12px;
  border-top: 1px solid var(--divider, #f1f5f9);
  font-size: 0.875rem;
  color: var(--text-muted, #64748b);
}

.nlp-message-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 18px;
  max-width: 100%;
}

.nlp-message-row.user {
  flex-direction: row-reverse;
}

.nlp-message-bubble {
  max-width: min(78%, 680px);
  padding: 13px 17px;
  border-radius: 14px;
  font-size: 0.9375rem;
  line-height: 1.55;
}

.nlp-message-row.user .nlp-message-bubble {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #fff;
  border-bottom-right-radius: 4px;
  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);
}

.nlp-message-row.bot .nlp-message-bubble {
  background: var(--surface, #fff);
  color: var(--text, #1e293b);
  border: 1px solid var(--border, #e2e8f0);
  border-bottom-left-radius: 4px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);
}

.nlp-message-bubble.error {
  color: var(--danger, #dc2626);
  border-color: #fecaca;
  background: #fef2f2;
}

.nlp-message-bubble.loading {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  color: var(--text-muted, #64748b);
}

.nlp-markdown { text-align: left; line-height: 1.6; }
.nlp-markdown p { margin: 0 0 0.5rem; }
.nlp-markdown p:last-child { margin-bottom: 0; }
.nlp-markdown a { color: #2563eb; font-weight: 500; }
.nlp-markdown strong { color: var(--text-strong, #0f172a); }

.nlp-spinner {
  width: 16px;
  height: 16px;
  border: 2px solid var(--border, #e2e8f0);
  border-top-color: #2563eb;
  border-radius: 50%;
  animation: nlp-spin 0.8s linear infinite;
}

@keyframes nlp-spin {
  to { transform: rotate(360deg); }
}

/* ── Floating input (mockup style) ── */
.nlp-input-area {
  flex-shrink: 0;
  padding: 12px 24px 20px;
  background: transparent;
}

.nlp-input-inner {
  max-width: 900px;
  margin: 0 auto;
}

.nlp-input-row {
  display: flex;
  align-items: center;
  gap: 10px;
  background: var(--surface, #fff);
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 16px;
  padding: 6px 8px 6px 18px;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.nlp-input-row:focus-within {
  border-color: #93c5fd;
  box-shadow: 0 4px 24px rgba(37, 99, 235, 0.12);
}

.nlp-textarea {
  flex: 1 1;
  border: none;
  outline: none;
  resize: none;
  font-size: 0.9375rem;
  font-family: inherit;
  color: var(--text, #1e293b);
  background: transparent;
  min-height: 24px;
  max-height: 120px;
  line-height: 1.5;
  padding: 10px 0;
}

.nlp-textarea::placeholder {
  color: var(--text-subtle, #94a3b8);
}

.nlp-mic-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: var(--surface-2, #f8fafc);
  color: var(--text-muted, #64748b);
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, color 0.15s ease;
}

.nlp-mic-btn:hover:not(:disabled) {
  background: #e2e8f0;
  color: #2563eb;
}

.nlp-mic-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.nlp-send-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: 12px;
  background: var(--nlp-send-bg);
  color: #fff;
  cursor: pointer;
  flex-shrink: 0;
  transition: background 0.15s ease, transform 0.1s ease;
}

.nlp-send-btn:hover:not(:disabled) {
  background: var(--nlp-send-hover);
  transform: translateY(-1px);
}

.nlp-send-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

.nlp-input-hint {
  text-align: center;
  margin: 8px 0 0;
  font-size: 0.75rem;
  color: var(--text-subtle, #94a3b8);
}

.nlp-input-hint kbd {
  display: inline-block;
  padding: 1px 5px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.8);
  border: 1px solid var(--border, #e2e8f0);
  font-size: 0.6875rem;
  font-family: inherit;
}

/* ── Grouping view ── */
.nlp-grouping-view {
  flex: 1 1;
  overflow-y: auto;
  padding: 24px;
  background: var(--nlp-canvas-bg);
}

.nlp-grouping-inner {
  max-width: 95%;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.nlp-grouping-card {
  background: var(--surface, #fff);
  border-radius: 14px;
  padding: 26px 30px;
  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.07);
  border: 1px solid var(--border, #e2e8f0);
}

.nlp-section-title {
  margin: 0 0 22px;
  padding-bottom: 14px;
  border-bottom: 1px solid var(--divider, #f1f5f9);
  font-size: 1.0625rem;
  font-weight: 700;
  color: var(--text-strong, #0f172a);
}

.nlp-filter-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 18px 16px;
  margin-bottom: 22px;
}

.nlp-filter-field {
  display: flex;
  flex-direction: column;
  gap: 7px;
  min-width: 0;
}

.nlp-filter-label {
  font-size: 0.6875rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  color: var(--text-muted, #64748b);
  text-transform: uppercase;
}

.nlp-filter-field select {
  width: 100%;
  padding: 10px 32px 10px 12px;
  border: 1px solid var(--border, #cbd5e1);
  border-radius: 10px;
  font-size: 0.875rem;
  font-family: inherit;
  color: var(--text, #1e293b);
  background-color: var(--surface, #fff);
  cursor: pointer;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-repeat: no-repeat;
  background-position: right 12px center;
}

.nlp-filter-field select:focus {
  outline: none;
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);
}

.nlp-slider-field {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 24px;
}

.nlp-slider {
  width: 100%;
  height: 6px;
  appearance: none;
  border-radius: 999px;
  outline: none;
  cursor: pointer;
  background: linear-gradient(
    to right,
    #2563eb 0%,
    #2563eb var(--slider-progress, 50%),
    #e2e8f0 var(--slider-progress, 50%),
    #e2e8f0 100%
  );
}

.nlp-slider::-webkit-slider-thumb {
  appearance: none;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #2563eb;
  border: 2px solid #fff;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.35);
  cursor: pointer;
}

.nlp-primary-btn {
  display: inline-flex;
  align-items: center;
  padding: 11px 24px;
  border: none;
  border-radius: 10px;
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);
  color: #fff;
  font-size: 0.9375rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.nlp-primary-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);
}

.nlp-filter-status {
  margin: 14px 0 0;
  font-size: 0.875rem;
  color: #16a34a;
  font-weight: 500;
}

.nlp-grouping-action-card {
  padding: 20px 30px;
}

.nlp-grouping-run-btn {
  width: 100%;
  padding: 17px 24px;
  border: none;
  border-radius: 12px;
  background: #93c5fd;
  color: #fff;
  font-size: 1.0625rem;
  font-weight: 700;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.15s ease, transform 0.1s ease;
}

.nlp-grouping-run-btn:hover:not(:disabled) {
  background: #60a5fa;
  transform: translateY(-1px);
}

.nlp-grouping-run-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

/* ── Responsive ── */
@media (max-width: 1100px) {
  .nlp-engine-header {
    flex-wrap: wrap;
    padding: 10px 14px;
  }

  .nlp-engine-header-right {
    width: 100%;
    justify-content: flex-start;
  }
}

@media (max-width: 1024px) {
  .nlp-filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 768px) {
  .nlp-engine-brand-meta {
    display: none;
  }

  .nlp-engine-grouping-btn span,
  .nlp-engine-new-btn span {
    display: none;
  }

  .nlp-engine-select {
    max-width: 130px;
    font-size: 0.75rem;
  }

  .nlp-messages {
    padding: 16px 12px 8px;
  }

  .nlp-welcome-card {
    padding: 16px 14px;
  }

  .nlp-input-area {
    padding: 10px 12px max(14px, env(safe-area-inset-bottom));
  }

  .nlp-message-bubble {
    max-width: 88%;
  }

  .nlp-filter-grid {
    grid-template-columns: 1fr;
  }

  .nlp-grouping-view {
    padding: 14px;
  }

  .nlp-grouping-card {
    padding: 18px 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/kedb/nlp-engine.css"],"names":[],"mappings":"AAAA,gEAAgE;;AAEhE;EACE,+EAA+E;EAC/E,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;;EAEzB,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,gCAAgC;EAChC,yFAAyF;AAC3F;;AAEA;EACE,wBAAwB;EACxB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gCAAgC;EAChC,WAAW;EACX,kDAAkD;EAClD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;;EAGE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,oBAAoB;EACpB,0DAA0D;EAC1D,mBAAmB;AACrB;;AAEA;;;EAGE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,2CAA2C;EAC3C,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,oBAAoB;EACpB,oBAAoB;EACpB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,yDAAqN;EACrN,4BAA4B;EAC5B,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,qDAAqD;EACrD,eAAe;EACf,cAAc;EACd,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,MAAM;AACR;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kCAAkC;EAClC,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,6CAA6C;EAC7C,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,+BAA+B;EAC/B,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,2BAA2B;EAC3B,wCAAwC;EACxC,8BAA8B;EAC9B,4CAA4C;AAC9C;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;EACT,iCAAiC;AACnC;;AAEA,gBAAgB,gBAAgB,EAAE,gBAAgB,EAAE;AACpD,kBAAkB,kBAAkB,EAAE;AACtC,6BAA6B,gBAAgB,EAAE;AAC/C,kBAAkB,cAAc,EAAE,gBAAgB,EAAE;AACpD,uBAAuB,kCAAkC,EAAE;;AAE3D;EACE,WAAW;EACX,YAAY;EACZ,wCAAwC;EACxC,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,KAAK,yBAAyB,EAAE;AAClC;;AAEA,wCAAwC;AACxC;EACE,cAAc;EACd,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,yBAAyB;EACzB,6CAA6C;EAC7C,wDAAwD;AAC1D;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,cAAc;EACd,sDAAsD;AACxD;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,oCAAoC;EACpC,wCAAwC;EACxC,oBAAoB;EACpB,oBAAoB;AACtB;;AAEA,wBAAwB;AACxB;EACE,SAAO;EACP,gBAAgB;EAChB,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gCAAgC;EAChC,mBAAmB;EACnB,kBAAkB;EAClB,6CAA6C;EAC7C,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gDAAgD;EAChD,oBAAoB;EACpB,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,iCAAiC;EACjC,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,4BAA4B;EAC5B,wCAAwC;EACxC,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,2BAA2B;EAC3B,sCAAsC;EACtC,eAAe;EACf,gBAAgB;EAChB,yDAAyN;EACzN,4BAA4B;EAC5B,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,gBAAgB;EAChB,oBAAoB;EACpB,aAAa;EACb,eAAe;EACf;;;;;;GAMC;AACH;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,6CAA6C;EAC7C,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,6DAA6D;EAC7D,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,uDAAuD;AACzD;;AAEA;EACE,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,qBAAqB;AACrB;EACE;IACE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,yDAAyD;EAC3D;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;AACF","sourcesContent":["/* BAInocular NLP Intelligence Engine — mockup-accurate layout */\n\n.nlp-engine-page {\n  --nlp-header-bg: linear-gradient(135deg, #1e40af 0%, #2563eb 55%, #3b82f6 100%);\n  --nlp-canvas-bg: #eef2f7;\n  --nlp-send-bg: #93c5fd;\n  --nlp-send-hover: #60a5fa;\n\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  background: var(--nlp-canvas-bg);\n  font-family: \"Poppins\", -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n[data-theme=\"dark\"] .nlp-engine-page {\n  --nlp-canvas-bg: #0f172a;\n  --nlp-send-bg: #3b82f6;\n  --nlp-send-hover: #2563eb;\n}\n\n/* ── Blue NLP header bar ── */\n.nlp-engine-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-shrink: 0;\n  padding: 10px 20px;\n  background: var(--nlp-header-bg);\n  color: #fff;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.12);\n  min-height: 56px;\n}\n\n.nlp-engine-header-left {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  min-width: 0;\n}\n\n.nlp-engine-brand-meta {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  min-width: 0;\n}\n\n.nlp-engine-subtitle {\n  font-size: 0.75rem;\n  font-weight: 600;\n  letter-spacing: 0.14em;\n  color: rgba(255, 255, 255, 0.95);\n  white-space: nowrap;\n}\n\n.nlp-engine-status {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 0.6875rem;\n  font-weight: 500;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.nlp-engine-status-dot {\n  width: 7px;\n  height: 7px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.nlp-engine-status.connected .nlp-engine-status-dot {\n  background: #4ade80;\n  box-shadow: 0 0 6px rgba(74, 222, 128, 0.7);\n}\n\n.nlp-engine-status.disconnected .nlp-engine-status-dot {\n  background: #f87171;\n  box-shadow: 0 0 6px rgba(248, 113, 113, 0.7);\n}\n\n.nlp-engine-header-right {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.nlp-engine-btn,\n.nlp-engine-icon-btn,\n.nlp-engine-new-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s ease, border-color 0.15s ease;\n  white-space: nowrap;\n}\n\n.nlp-engine-btn:hover,\n.nlp-engine-icon-btn:hover,\n.nlp-engine-new-btn:hover {\n  background: rgba(255, 255, 255, 0.22);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.nlp-engine-grouping-btn {\n  height: 34px;\n  padding: 0 12px;\n  border-radius: 8px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n}\n\n.nlp-engine-grouping-btn.active {\n  background: rgba(255, 255, 255, 0.28);\n  border-color: rgba(255, 255, 255, 0.65);\n}\n\n.nlp-engine-select {\n  height: 34px;\n  padding: 0 28px 0 10px;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  border-radius: 8px;\n  background: rgba(255, 255, 255, 0.12);\n  color: #fff;\n  font-size: 0.8125rem;\n  font-family: inherit;\n  font-weight: 500;\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='white' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 8px center;\n}\n\n.nlp-engine-select option {\n  color: #1e293b;\n  background: #fff;\n}\n\n.nlp-engine-icon-btn {\n  width: 34px;\n  height: 34px;\n  border-radius: 8px;\n  padding: 0;\n  flex-shrink: 0;\n}\n\n.nlp-engine-theme-dot {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.55);\n  background: linear-gradient(135deg, #f472b6, #818cf8);\n  cursor: pointer;\n  flex-shrink: 0;\n  padding: 0;\n}\n\n.nlp-engine-new-btn {\n  height: 34px;\n  padding: 0 12px;\n  border-radius: 8px;\n  font-size: 0.8125rem;\n  font-weight: 600;\n}\n\n/* ── Body ── */\n.nlp-engine-body {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n  overflow: hidden;\n  background: var(--nlp-canvas-bg);\n}\n\n/* ── Chat view ── */\n.nlp-chat-view {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  min-height: 0;\n}\n\n.nlp-messages {\n  flex: 1;\n  overflow-y: auto;\n  padding: 28px 24px 12px;\n  scroll-behavior: smooth;\n}\n\n.nlp-messages-inner {\n  max-width: 900px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 0;\n}\n\n.nlp-messages::-webkit-scrollbar {\n  width: 6px;\n}\n\n.nlp-messages::-webkit-scrollbar-thumb {\n  background: var(--scrollbar-thumb, #cbd5e1);\n  border-radius: 3px;\n}\n\n.nlp-welcome-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 8px;\n}\n\n.nlp-bot-avatar {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #2563eb, #3b82f6);\n  color: #fff;\n  font-size: 0.875rem;\n  font-weight: 800;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.25);\n}\n\n.nlp-bot-avatar-sm {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  font-size: 0.75rem;\n  margin-top: 2px;\n}\n\n.nlp-welcome-card {\n  flex: 1;\n  min-width: 0;\n  background: var(--surface, #fff);\n  border-radius: 14px;\n  padding: 22px 26px;\n  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.07);\n  border: 1px solid var(--border, #e2e8f0);\n}\n\n.nlp-welcome-time {\n  display: block;\n  font-size: 0.75rem;\n  color: var(--text-subtle, #94a3b8);\n  margin-bottom: 8px;\n}\n\n.nlp-welcome-title {\n  margin: 0 0 14px;\n  font-size: 1.0625rem;\n  font-weight: 700;\n  color: #2563eb;\n  line-height: 1.4;\n}\n\n.nlp-welcome-heading {\n  margin: 0 0 10px;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: var(--text-strong, #0f172a);\n}\n\n.nlp-feature-list {\n  list-style: none;\n  margin: 0 0 14px;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.nlp-feature-list li {\n  display: flex;\n  align-items: flex-start;\n  gap: 8px;\n  font-size: 0.875rem;\n  color: var(--text-muted, #64748b);\n  line-height: 1.5;\n}\n\n.nlp-feature-list li strong {\n  color: var(--text-strong, #0f172a);\n  font-weight: 600;\n}\n\n.nlp-feature-icon {\n  flex-shrink: 0;\n  font-size: 1rem;\n  line-height: 1.35;\n}\n\n.nlp-welcome-footer {\n  margin: 0;\n  padding-top: 12px;\n  border-top: 1px solid var(--divider, #f1f5f9);\n  font-size: 0.875rem;\n  color: var(--text-muted, #64748b);\n}\n\n.nlp-message-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  margin-bottom: 18px;\n  max-width: 100%;\n}\n\n.nlp-message-row.user {\n  flex-direction: row-reverse;\n}\n\n.nlp-message-bubble {\n  max-width: min(78%, 680px);\n  padding: 13px 17px;\n  border-radius: 14px;\n  font-size: 0.9375rem;\n  line-height: 1.55;\n}\n\n.nlp-message-row.user .nlp-message-bubble {\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: #fff;\n  border-bottom-right-radius: 4px;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, 0.2);\n}\n\n.nlp-message-row.bot .nlp-message-bubble {\n  background: var(--surface, #fff);\n  color: var(--text, #1e293b);\n  border: 1px solid var(--border, #e2e8f0);\n  border-bottom-left-radius: 4px;\n  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.05);\n}\n\n.nlp-message-bubble.error {\n  color: var(--danger, #dc2626);\n  border-color: #fecaca;\n  background: #fef2f2;\n}\n\n.nlp-message-bubble.loading {\n  display: inline-flex;\n  align-items: center;\n  gap: 10px;\n  color: var(--text-muted, #64748b);\n}\n\n.nlp-markdown { text-align: left; line-height: 1.6; }\n.nlp-markdown p { margin: 0 0 0.5rem; }\n.nlp-markdown p:last-child { margin-bottom: 0; }\n.nlp-markdown a { color: #2563eb; font-weight: 500; }\n.nlp-markdown strong { color: var(--text-strong, #0f172a); }\n\n.nlp-spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid var(--border, #e2e8f0);\n  border-top-color: #2563eb;\n  border-radius: 50%;\n  animation: nlp-spin 0.8s linear infinite;\n}\n\n@keyframes nlp-spin {\n  to { transform: rotate(360deg); }\n}\n\n/* ── Floating input (mockup style) ── */\n.nlp-input-area {\n  flex-shrink: 0;\n  padding: 12px 24px 20px;\n  background: transparent;\n}\n\n.nlp-input-inner {\n  max-width: 900px;\n  margin: 0 auto;\n}\n\n.nlp-input-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  background: var(--surface, #fff);\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 16px;\n  padding: 6px 8px 6px 18px;\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n.nlp-input-row:focus-within {\n  border-color: #93c5fd;\n  box-shadow: 0 4px 24px rgba(37, 99, 235, 0.12);\n}\n\n.nlp-textarea {\n  flex: 1;\n  border: none;\n  outline: none;\n  resize: none;\n  font-size: 0.9375rem;\n  font-family: inherit;\n  color: var(--text, #1e293b);\n  background: transparent;\n  min-height: 24px;\n  max-height: 120px;\n  line-height: 1.5;\n  padding: 10px 0;\n}\n\n.nlp-textarea::placeholder {\n  color: var(--text-subtle, #94a3b8);\n}\n\n.nlp-mic-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border: none;\n  border-radius: 50%;\n  background: var(--surface-2, #f8fafc);\n  color: var(--text-muted, #64748b);\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s ease, color 0.15s ease;\n}\n\n.nlp-mic-btn:hover:not(:disabled) {\n  background: #e2e8f0;\n  color: #2563eb;\n}\n\n.nlp-mic-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.nlp-send-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border: none;\n  border-radius: 12px;\n  background: var(--nlp-send-bg);\n  color: #fff;\n  cursor: pointer;\n  flex-shrink: 0;\n  transition: background 0.15s ease, transform 0.1s ease;\n}\n\n.nlp-send-btn:hover:not(:disabled) {\n  background: var(--nlp-send-hover);\n  transform: translateY(-1px);\n}\n\n.nlp-send-btn:disabled {\n  opacity: 0.45;\n  cursor: not-allowed;\n}\n\n.nlp-input-hint {\n  text-align: center;\n  margin: 8px 0 0;\n  font-size: 0.75rem;\n  color: var(--text-subtle, #94a3b8);\n}\n\n.nlp-input-hint kbd {\n  display: inline-block;\n  padding: 1px 5px;\n  border-radius: 4px;\n  background: rgba(255, 255, 255, 0.8);\n  border: 1px solid var(--border, #e2e8f0);\n  font-size: 0.6875rem;\n  font-family: inherit;\n}\n\n/* ── Grouping view ── */\n.nlp-grouping-view {\n  flex: 1;\n  overflow-y: auto;\n  padding: 24px;\n  background: var(--nlp-canvas-bg);\n}\n\n.nlp-grouping-inner {\n  max-width: 95%;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n}\n\n.nlp-grouping-card {\n  background: var(--surface, #fff);\n  border-radius: 14px;\n  padding: 26px 30px;\n  box-shadow: 0 2px 16px rgba(15, 23, 42, 0.07);\n  border: 1px solid var(--border, #e2e8f0);\n}\n\n.nlp-section-title {\n  margin: 0 0 22px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid var(--divider, #f1f5f9);\n  font-size: 1.0625rem;\n  font-weight: 700;\n  color: var(--text-strong, #0f172a);\n}\n\n.nlp-filter-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 18px 16px;\n  margin-bottom: 22px;\n}\n\n.nlp-filter-field {\n  display: flex;\n  flex-direction: column;\n  gap: 7px;\n  min-width: 0;\n}\n\n.nlp-filter-label {\n  font-size: 0.6875rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  color: var(--text-muted, #64748b);\n  text-transform: uppercase;\n}\n\n.nlp-filter-field select {\n  width: 100%;\n  padding: 10px 32px 10px 12px;\n  border: 1px solid var(--border, #cbd5e1);\n  border-radius: 10px;\n  font-size: 0.875rem;\n  font-family: inherit;\n  color: var(--text, #1e293b);\n  background-color: var(--surface, #fff);\n  cursor: pointer;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2'%3E%3Cpath d='M6 9l6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n}\n\n.nlp-filter-field select:focus {\n  outline: none;\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.15);\n}\n\n.nlp-slider-field {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 24px;\n}\n\n.nlp-slider {\n  width: 100%;\n  height: 6px;\n  appearance: none;\n  border-radius: 999px;\n  outline: none;\n  cursor: pointer;\n  background: linear-gradient(\n    to right,\n    #2563eb 0%,\n    #2563eb var(--slider-progress, 50%),\n    #e2e8f0 var(--slider-progress, 50%),\n    #e2e8f0 100%\n  );\n}\n\n.nlp-slider::-webkit-slider-thumb {\n  appearance: none;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  background: #2563eb;\n  border: 2px solid #fff;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.35);\n  cursor: pointer;\n}\n\n.nlp-primary-btn {\n  display: inline-flex;\n  align-items: center;\n  padding: 11px 24px;\n  border: none;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%);\n  color: #fff;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: transform 0.15s ease, box-shadow 0.15s ease;\n}\n\n.nlp-primary-btn:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.25);\n}\n\n.nlp-filter-status {\n  margin: 14px 0 0;\n  font-size: 0.875rem;\n  color: #16a34a;\n  font-weight: 500;\n}\n\n.nlp-grouping-action-card {\n  padding: 20px 30px;\n}\n\n.nlp-grouping-run-btn {\n  width: 100%;\n  padding: 17px 24px;\n  border: none;\n  border-radius: 12px;\n  background: #93c5fd;\n  color: #fff;\n  font-size: 1.0625rem;\n  font-weight: 700;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.15s ease, transform 0.1s ease;\n}\n\n.nlp-grouping-run-btn:hover:not(:disabled) {\n  background: #60a5fa;\n  transform: translateY(-1px);\n}\n\n.nlp-grouping-run-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n/* ── Responsive ── */\n@media (max-width: 1100px) {\n  .nlp-engine-header {\n    flex-wrap: wrap;\n    padding: 10px 14px;\n  }\n\n  .nlp-engine-header-right {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n@media (max-width: 1024px) {\n  .nlp-filter-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 768px) {\n  .nlp-engine-brand-meta {\n    display: none;\n  }\n\n  .nlp-engine-grouping-btn span,\n  .nlp-engine-new-btn span {\n    display: none;\n  }\n\n  .nlp-engine-select {\n    max-width: 130px;\n    font-size: 0.75rem;\n  }\n\n  .nlp-messages {\n    padding: 16px 12px 8px;\n  }\n\n  .nlp-welcome-card {\n    padding: 16px 14px;\n  }\n\n  .nlp-input-area {\n    padding: 10px 12px max(14px, env(safe-area-inset-bottom));\n  }\n\n  .nlp-message-bubble {\n    max-width: 88%;\n  }\n\n  .nlp-filter-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .nlp-grouping-view {\n    padding: 14px;\n  }\n\n  .nlp-grouping-card {\n    padding: 18px 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
